import { Location } from '@reach/router';

const withLocation = (Component) => (props) => (
	<Location>
		{({ location }) => {
			const splitPath = location.pathname.slice(1).replace(/\/$/, ``).split(`/`);

			return (
				<Component
					{...props}
					location={location}
					splitPath={splitPath}
					search={typeof window !== 'undefined' ? window.location.search : location.search}
				/>
			);
		}}
	</Location>
);

export default withLocation;
